import getFragmentHandler from './getFragmentHandler';

export default (route: string): string => {
  const fragmentHandler = getFragmentHandler();

  if (fragmentHandler === null) {
    return route;
  }

  return `${route}${fragmentHandler.getFragmentString()}`;
};
